import { dispatch } from '../index.js'
import { MAILFOOTER } from 'config/actionTypes'
import { getEditorState } from 'firebase/database/mailFooterHandler.js'
export const initEditor = payload => {
    return getEditorState()
}
export const setFooterActive = payload => {
    return dispatch({type: MAILFOOTER.SET_ACTIVE, payload})
}
export const setEditorState = payload => {
    return dispatch({type: MAILFOOTER.SET_EDITOR_STATE, payload})
}

export const resetEditorState = payload => {
    return dispatch({type: MAILFOOTER.RESET_EDITOR_STATE})
}

export const addImageLink = payload => {
    return dispatch({type: MAILFOOTER.SET_IMAGE_LINK, payload})
}

export const setFooterRecipients = payload =>dispatch({type: MAILFOOTER.SET_FOOTER_RECIPIENT, payload})